import React from 'react';
import { connect } from 'react-redux';
import Error from 'commons/src/components/errorComponents/Error';
import { getSelectedGroupFromStorage } from 'commons/src/components/findUserType';
import BuildInfo from 'commons/src/features/settingsPage/BuildInfo';
import LicenseSection from 'commons/src/features/settingsPage/LicensesSection';
import UserInfo from 'commons/src/features/settingsPage/UserSettings/UserInfo';
import UserPreferences from 'commons/src/features/settingsPage/UserSettings/UserPreferences';
import { SelectedGroup } from 'commons/src/models/commonTypeScript';
import { Store } from 'commons/src/reducers';
import WeeklyReportSignUp from './WeeklyReportSignUp';

type Props = {
    appError: boolean;
};

const Overview = ({ appError }: Props): React.ReactElement => {
    const selectedGroup: SelectedGroup | null = getSelectedGroupFromStorage();

    if (appError) {
        return <Error />;
    }
    return (
        <div>
            <UserInfo />
            <UserPreferences />
            {selectedGroup?.userGroupId && <WeeklyReportSignUp />}
            <LicenseSection />
            <BuildInfo />
        </div>
    );
};

const mapStateToProps = (store: Store): Props => {
    const {
        app: { error },
    } = store;
    return {
        appError: error,
    };
};

export default connect(mapStateToProps)(Overview);
